import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { ClothStockMaster, StockMenu } from '../../TitleList';

import { VscArrowSmallRight, VscArrowSmallLeft } from "react-icons/vsc";
import { fetchManualStkReg, fetchStkProductionReg } from '../../../Store/PHPSlice/Stock/StockApis';
import { selectManualStkReg, selectStkProductionReg } from '../../Selectors/StitchSelector/StitchingSelectors';

const ManualStkReg = () => {
    const dispatch = useDispatch();

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    // const stkProdReg = useSelector(selectStkProductionReg);
    const stkProdReg = useSelector(selectManualStkReg);

    useEffect(() => {
        // dispatch(fetchStkProductionReg());
        dispatch(fetchManualStkReg());
    }, [dispatch]);

    if (!stkProdReg) {
        return <h1>Loading...</h1>;
    }

    const compData = Array.isArray(stkProdReg.data) ? stkProdReg.data.map((item, index) => (
        {
            srno: item.ID,
            dt: item.date,
            icode: item.icode,
            itemId: item.itemId,
            itemNm: item.itemNm,
            pksts: item.pksts,
            sts: item.sts,
            barcode: item.barcode,
            size: item.size,
            qty: item.qty,
            balqty: item.balqty,
            mclothNm: item.mclothNm,
            m1clothNm: item.m1clothNm,
            m2clothNm: item.m2clothNm,
            m3clothNm: item.m3clothNm,
            color: item.color,
            shadeNo: item.shadeNo,
            rate: item.rate,
            rack: item.rack,
            locNm: item.locNm,
            serialNumber: index + 1
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        (item.dt && item.dt.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.itemNm && item.itemNm.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.barcode && item.barcode.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.rack && item.rack.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.mclothNm && item.mclothNm.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.size && item.size.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.locNm && item.locNm.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // console.log(stkProdReg.data)
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    return (
        <>
            <Titlebar data={StockMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Manual Stock (Barcode) Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'barcode', label: 'Barcode' },
                                                { id: 'itemNm', label: 'Item' },
                                                 { id: 'mclothNm', label: 'Cloth' },
                                                // { id: 'color', label: 'Color' },
                                                // { id: 'shadeNo', label: 'Shade No.' },
                                                { id: 'size', label: 'Size' },
                                                { id: 'rate  ', label: 'Rate' },
                                                { id: 'qty  ', label: 'Qty' },
                                                { id: 'balqty', label: 'Bal Qty' },
                                                { id: 'rack  ', label: 'Rack' },
                                                { id: 'locNm  ', label: 'Location' },
                                                // { id: '', label: 'Edit' },
                                                // { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>


                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                dt={row.dt}
                                                icode={row.icode}
                                                qty={row.qty}
                                                balqty={row.balqty}
                                                itemId={row.itemId}
                                                itemNm={row.itemNm}
                                                barcode={row.barcode}
                                                size={row.size}
                                                pksts={row.pksts}
                                                sts={row.sts}
                                                mclothNm={row.mclothNm}
                                                m1clothNm={row.m1clothNm}
                                                m2clothNm={row.m2clothNm}
                                                m3clothNm={row.m3clothNm}
                                                color={row.color}
                                                shadeNo={row.shadeNo}
                                                rate={row.rate}
                                                rack={row.rack}
                                                locNm={row.locNm}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default ManualStkReg;
